import { createActionGroup, emptyProps, props } from "@ngrx/store";
import { CreateStandardInterface, StandardInterface, onClose } from "src/app/shared/interfaces";

export const standardActions = createActionGroup({
    source: "standard",
    events: {
        "load standards": emptyProps(),
        "set standards": props<{ data: StandardInterface[] }>(),
        "load standards for admission": props<{ academic_year: string }>(),
        "load active academic year standards": props<{ admission_enabled: boolean }>(),
        "set active academic year standards": props<{ data: StandardInterface[] }>(),
        "load standards by academic year": props<{ academic_year: string }>(),
        "load active standards": emptyProps(),
        "set active standards": props<{ data: StandardInterface[] }>(),
        "load inactive standards": emptyProps(),
        "set inactive standards": props<{ data: StandardInterface[] }>(),
        "load standards for fees": emptyProps(),
        "set standards for fees": props<{ data: StandardInterface[] }>(),
        create: props<{
            data: CreateStandardInterface;
            onClose: onClose;
        }>(),
        update: props<{
            data: CreateStandardInterface;
            id: string;
            onClose: onClose;
        }>(),
    },
});
